import { render } from "./IpServicoSelect.vue?vue&type=template&id=5e261694"
import script from "./IpServicoSelect.vue?vue&type=script&lang=js"
export * from "./IpServicoSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__